import Tabs from './Tabs';

class TabsVenue extends Tabs {
  // override `afterOpen() to prevent tab has update
  public afterOpen() {
    return this;
  }
}

export default TabsVenue;
